const module = {
  config: {
    name: "aktifitas",
    svg: "../static/img/icon/menu/survey.svg",
    desc: "Berisi modul perkembangan bibit.",
    layout: true
  },
  routes: [
    {
      name: "Aktifitas Sarpras",
      icon: "ri-building-line",
      path: "/sarana-prasarana",
      component: () => import("./sarpras/list.vue"),
      separator: "Sarana Prasarana"
    },
    {
      name: "Pengadaan",
      icon: "ri-projector-line",
      path: "/request-procurement-seeds",
      component: () => import("./request-procurement-seeds.vue"),
      separator: "Pengadaan Benih & Bibit"
    },
    {
      name: "Penerimaan (BAST)",
      icon: "ri-projector-2-line",
      path: "/delivery_po",
      component: () => import("./delivery-po.vue"),
      separator: "Pengadaan Benih & Bibit"
    },
        {
      name : "Pengadaan Lokal",
      icon: "ri-projector-line",
      path: "/request-procurement-local",
      component: () => import("./procurement-local/main/request-procurement-local.vue"),
      separator: "Pengadaan Benih & Bibit"
    },
    {
      name: "Perlakuan Benih",
      icon: "ri-flask-line",
      path: "/seed-treatment",
      component: () => import("./seed-treatment.vue"),
      separator: "Aktifitas Pembibitan"
    },
    {
      name: "Sampling Benih",
      icon: "ri-hand-coin-line",
      path: "/sampling-seeds",
      component: () => import("./main-activity/sampling.vue"),
      separator: "Aktifitas Pembibitan"
    },
    {
      name: "Penaburan & Penanaman",
      icon: "ri-bubble-chart-line",
      path: "/penaburan-penanaman",
      component: () => import("./main-activity/harvest-plant.vue"),
      separator: "Aktifitas Pembibitan"
    },
    {
      name: "Penyapihan & BBST",
      icon: "ri-seedling-line",
      path: "/penyapihan-bbst",
      component: () => import("./main-activity/bbst.vue"),
      separator: "Aktifitas Pembibitan"
    },
    {
      name: "BST",
      icon: "ri-plant-line",
      path: "/bst",
      component: () => import("./main-activity/bst.vue"),
      separator: "Aktifitas Pembibitan"
    },
    {
      name: "Jadwal Pemeliharaan",
      icon: "ri-calendar-2-line",
      path: "/pemeliharaan-reguler-pengawas",
      component: () => import("./main-activity/pemeliharaan-reguler-pengawas.vue"),
      separator: "Pemeliharaan Bedeng"
    },
    {
      name: "Bedeng",
      icon: "ri-building-4-line",
      path: "/report-activities-bedeng",
      component: () => import("./report/bedeng/index.vue"),
      separator: "Report Activities"
    },
    {
      name: "Tanaman",
      icon: "ri-flower-line",
      path: "/report-activities-tanaman",
      component: () => import("./report/tanaman/index.vue"),
      separator: "Report Activities"
    },
    // {
    //   name: "Bedeng Tabur",
    //   icon: "ri-barricade-fill",
    //   path: "/monitoring-bedeng-tabur",
    //   component: () => import("./monitoring-bedeng/index.vue"),
    //   separator: "Monitoring"
    // },
    // {
    //   name: "Bedeng Tanam",
    //   icon: "ri-barricade-fill",
    //   path: "/monitoring-bedeng-sapih",
    //   component: () => import("./monitoring-bedeng/index.vue"),
    //   separator: "Monitoring"
    // }
    // {
    //   name: "Pemesanan Bedeng",
    //   icon: "ri-hand-coin-line",
    //   path: "/booking-bedeng",
    //   component: () => import("./bedeng/booking.vue"),
    //   separator: "Bedeng"
    // },
    // {
    //   name: "Pengadaan Bibit",
    //   icon: "ri-hand-coin-line",
    //   path: "/received-seeds",
    //   component: () => import("./received-seeds.vue"),
    //   separator: "Bibit"
    // }
    // {
    //   name: "Aktifitas Bibit",
    //   icon: "ri-survey-line",
    //   path: "/activity-seeds",
    //   component: () => import("./activity-seeds.vue"),
    //   separator: "Bibit"
    // },
    // {
    //   name: "Quality Check Bibit",
    //   icon: "ri-honour-fill",
    //   path: "/qa-seeds",
    //   component: () => import("./quality-check-seed.vue"),
    //   separator: "Bibit"
    // },
    // {
    //   name: "Monitoring QC Bibit",
    //   icon: "ri-bubble-chart-fill",
    //   path: "/log-monitoring-seeds",
    //   component: () => import("./log-freelance-monitoring.vue"),
    //   separator: "Log Bibit"
    // },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/activities/_index.js